var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(Array.isArray(_vm.itemData)) ? _c('div', [_c('div', {
    staticClass: "collection-item",
    class: 'is-' + _vm.itemData.length,
    style: ('background-image: url(' + _vm.imagePath(_vm.itemData[0]) + ')')
  }), _vm._v(" "), _c('h4', {
    staticClass: "title is-5",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.title))
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "subtitle is-6"
  }, [_vm._v("Group: " + _vm._s(_vm.itemData.length) + " items")])]) : _c('div', [_c('div', {
    staticClass: "collection-item is-1",
    style: ('background-image: url(' + _vm.imagePath(_vm.itemData) + ')')
  }), _vm._v(" "), _c('h4', {
    staticClass: "title is-5",
    domProps: {
      "innerHTML": _vm._s(_vm.markdown(_vm.title))
    }
  })])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eb63a84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ArchiveCollectionItem.vue
// module id = geIg
// module chunks = 0